import { AppModal } from '@/components/shared/modal'

import { FeedbackCompletedContent } from './FeedbackCompletedContent'

type Props = {
  visible: boolean
  onClose: () => void
}

const FeedbackCompletedModal = ({ visible, onClose }: Props) => (
  <AppModal className="w-[480px]" opened={visible} onClose={onClose}>
    <FeedbackCompletedContent onClose={onClose} />
  </AppModal>
)

export { FeedbackCompletedModal }
